import axios from 'axios'
const GlobalConfig = {

  install(Vue) {
    Vue.mixin({
      methods: {
        /*
          Calculate the Age based on date passed (YYYY-MM-DD) to the function
        */
        calculateAge(year, month, day) {
          var today = new Date()
          var birthDate = new Date(year, month, day)
          var age = today.getFullYear() - birthDate.getFullYear()
          var m = today.getMonth() - birthDate.getMonth()
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--
          }
          return age
        },
        getExternalContactPreferences(ssoid) {
          return new Promise((resolve) => {
            console.log('Attempting to get contact prefernces from external source')
            switch (this.configValues.contactPreferencesParentSystem) {
              case 'XCM':
                resolve(this.crmXCMGetPreferences())
                break;
              case 'Dummy':
                resolve(this.dummyCRMGetPreferences())
                break;
              default:
                resolve(null)
                break;
            }
          })
        },
        dummyCRMGetPreferences() {
          return new Promise((resolve) => {
            console.log('triggered dummy crm push')
            var dummyUserData = {
              clubEmail: 'Y',
              clubPhone: 'Y',
              clubDirect: 'Y',
              clubSMS: 'Y'
            }
            resolve(dummyUserData)
          })
        },
        dummyCRMPushFunction() {
          return new Promise((resolve) => {
            console.log('triggered dummy crm push')
            resolve()
          })
        },
        crmXCMPushFunction(username) {
          var crmXCMPushURL = this.configValuesxcmConfig.pushDataEndpoint + username
          console.log('XCM push url', crmXCMPushURL)
          return axios({
            method: 'get',
            url: crmXCMPushURL
          })
        },
        crmXCMGetPreferences(ssoid) {
          return new Promise((resolve, reject) => {

            var crmURL = this.configValuesxcmConfig.contactPreferencesEndpoint + ssoid
            console.log('XCM push url', crmURL)
            axios({
              method: 'get',
              url: crmURL
            }).then(function (response) {
              console.log('XCM response', response)
              if (response.data.success === true) {
                console.log('XCM prefs found, setting local values to XCM values')
                var xcmData = response.data.data.Preferences
                var userData = {} // a dummy object to place our normalised data back into
                userData.clubEmail = ((xcmData['Email']['Club Communication'] == 'Y') ? true : false)
                userData.clubDirect = ((xcmData['Direct Mail']['Club Communication'] == 'Y') ? true : false)
                userData.clubPhone = ((xcmData['Phone']['Club Communication'] == 'Y') ? true : false)
                userData.clubSMS = ((xcmData['SMS']['Club Communication'] == 'Y') ? true : false)
                userData.partnerEmail = ((xcmData['Email']['Partner Communication'] == 'Y') ? true : false)
                userData.partnerDirect = ((xcmData['Direct Mail']['Partner Communication'] == 'Y') ? true : false)
                userData.partnerPhone = ((xcmData['Phone']['Partner Communication'] == 'Y') ? true : false)
                userData.partnerSMS = ((xcmData['SMS']['Partner Communication'] == 'Y') ? true : false)
                userData.clubAds = ((xcmData['Digital Ads']['Club Communication'] == "Y") ? true : false)
                userData.foundationEmail = ((xcmData['Email']['AV Foundation'] == "Y") ? true : false)
                userData.partnerAds = ((xcmData['Digital Ads']['Partner Communication'] == "Y") ? true : false)
                resolve(userData)
              } else {
                reject(new Error('XCM failed to respond'))
              }
            })
          })
        },
        dataPush(username) {
          return new Promise((resolve) => {
            console.log('Establishing enpoints to push data')
            // build list of data push functions that we need to trigger
            var dataPushFunctions = []

            if (this.configValues.dummyCRMEnabled === true) {
              dataPushFunctions.push(this.dummyCRMPushFunction)
            }

            if (this.configValues.xcmCRMIntegrationEnabled === true) {
              dataPushFunctions.push(this.crmXCMPushFunction)
            }

            Promise.all(dataPushFunctions)
              .then(function (results) {
                console.log('CRM update results', results[0])
                resolve()
              })
          })
        },
        ticketMasterLink(tmid) {
          var vm = this
          return new Promise(function (resolve, reject) {
            console.log('ticketmaster link account')


            if (vm.$getAuthenticatedUser() == null) {
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              // check to see if the user was created with traditional registration (and not Facebook or Google)
              //get this session's tokens
              var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
              var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)

              vm.$getCurrentUserAttributes().subscribe((userData) => {

                if (userData['custom:client_ref_verified'] !== 'true') {
                  console.log('generating user login token')

                  var ssoid = userData['sub']


                  //check if the user exists
                  axios({
                    method: 'get',
                    headers: { 'Authorization': idToken },
                    url: vm.configValues.ticketMasterConfig.uzTMLinkEnpoint + ssoid + '/' + tmid
                  }).then(function (response) {
                    console.log('Token endpoint reponse', response)

                    resolve(response.data)
                  })

                } else {
                  reject({ success: false, message: "Unable to link as existing link does not exist" })
                }
              })

            }
          })
        },
        ticketMasterUnlink() {
          var vm = this
          return new Promise(function (resolve, reject) {
            console.log('ticketmaster link account')


            if (vm.$getAuthenticatedUser() == null) {
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              // check to see if the user was created with traditional registration (and not Facebook or Google)
              //get this session's tokens
              var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
              var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)

              vm.$getCurrentUserAttributes().subscribe((userData) => {

                if (userData['custom:client_ref_verified'] === 'true') {
                  console.log('generating user login token')

                  var ssoid = userData['sub']


                  //check if the user exists
                  axios({
                    method: 'get',
                    headers: { 'Authorization': idToken },
                    url: vm.configValues.ticketMasterConfig.uzTMUnlinkEnpoint + ssoid
                  }).then(function (response) {
                    console.log('Token endpoint reponse', response)

                    resolve(response.data)
                  })

                } else {
                  reject({ success: false, message: "Unable to unlink as existing link does not exist" })
                }
              })

            }
          })
        },
        ticketMasterCreate() {
          var vm = this
          return new Promise(function (resolve, reject) {
            console.log('ticketmaster create and link account')


            if (vm.$getAuthenticatedUser() == null) {
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              // check to see if the user was created with traditional registration (and not Facebook or Google)
              //get this session's tokens
              var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
              var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)

              vm.$getCurrentUserAttributes().subscribe((userData) => {

                if (userData['custom:client_ref_verified'] !== 'true') {
                  console.log('generating user login token')

                  var ssoid = userData['sub']


                  //check if the user exists
                  axios({
                    method: 'get',
                    headers: { 'Authorization': idToken },
                    url: vm.configValues.ticketMasterConfig.uzTMCreateEnpoint + ssoid
                  }).then(function (response) {
                    console.log('Token endpoint reponse', response)

                    resolve(response.data)
                  })

                } else {
                  reject({ success: false, message: "Unable to create as existing user is linked" })
                }
              })

            }
          })
        },
        ticketMasterGenerateToken() {
          var vm = this
          return new Promise(function (resolve, reject) {
            if (vm.$getAuthenticatedUser() == null) {
              console.log('User is not logged in')
              vm.$router.push("/");
            } else {
              // check to see if the user was created with traditional registration (and not Facebook or Google)
              vm.$getCurrentUserAttributes().subscribe((userData) => {
                if (userData['custom:client_ref_verified'] === 'true') {
                  console.log('generating user login token')

                  var ssoid = userData['sub']

                  //get this session's tokens
                  var lastSub = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
                  var idToken = vm.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)

                  //check if the user exists
                  axios({
                    method: 'get',
                    headers: { 'Authorization': idToken },
                    url: vm.configValues.ticketMasterConfig.uzTokenEnpoint + ssoid
                  }).then(function (response) {
                    console.log('Token endpoint reponse', response)

                    console.log('redirecting to ', response.data.returnurl)
                    resolve(response.data.returnurl)
                  })

                } else {
                  console.log('User not verified by ticketmaster, acocunt must be linked')
                  resolve(false)
                }
              })

            }
          })
        },
        ticketMasterRedirectWithToken() {
          console.log('ticketmaster token generation')

          if (this.$getAuthenticatedUser() == null) {
            console.log('User is not logged in')
            this.$router.push("/");
          } else {
            // check to see if the user was created with traditional registration (and not Facebook or Google)
            this.$getCurrentUserAttributes().subscribe((userData) => {
              if (userData['custom:client_ref_verified'] === 'true') {
                console.log('generating user login token')

                var ssoid = userData['sub']

                //get this session's tokens
                var lastSub = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
                var idToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)

                //check if the user exists
                axios({
                  method: 'get',
                  headers: { 'Authorization': idToken },
                  url: this.configValues.ticketMasterConfig.uzTokenEnpoint + ssoid
                }).then(function (response) {
                  console.log('Token endpoint reponse', response)
                  //clear any redirect cookies
                  localStorage.removeItem('returnUrl');
                  localStorage.removeItem('suppressToken');
                  localStorage.removeItem('responseType');
                  localStorage.removeItem('loginFlow');
                  console.log('redirecting to ', response.data.returnurl)
                  window.location = response.data.returnurl

                  return true
                })

              } else {
                console.log('User not verified by ticketmaster, acocunt must be linked')

              }
            })

          }
        },
        /*
          An array of domains that the site trusts in order to perform redirects
          */
        getConfigTrustedDomains() {
          var trustedDomains = []
          this.configTrustedPlatforms.forEach(platform => {
            platform.domains.forEach(domain => {
              trustedDomains.push(domain)
            })
          })
          return trustedDomains
        },
        /*
        Gets the redirect platform info (set by app in localStorage.redirectPlatform)
        */
        getRedirectPlatform() {
          var platform = this.configTrustedPlatforms.find(plat => {
            //TODO: remove this hardcoded URL
            var returnUrl = localStorage.returnUrl
            var found = false
            plat.domains.forEach(domain => {
              if (returnUrl.includes(domain)) {
                found = true
              }
            })
            return found
          })
          return platform
        },

        getPlatformRequiresAddress() {
          console.log('getPlatformRequiresAddress called')
          return this.getRedirectPlatform().requireAddress
        },

        getPlatformRequiresAddressMessage() {
          console.log('getPlatformRequiresAddressMessage called')
          return this.getRedirectPlatform().requireAddressMessage
        },

        getPlatformRequiresAddressButton() {
          console.log('getPlatformRequiresAddressMessage called')
          return this.getRedirectPlatform().requireAddressButton
        },
        performRedirect() {
          console.log('Performing standard redirect')
          var firstQueryChar = '?'
          if (localStorage.returnUrl.includes('?')) { // account for ? in string
            firstQueryChar = '&'
          }
          var redirect = localStorage.returnUrl
          var lastSub = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
          var idToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)
          if (!localStorage.suppressToken) {
            redirect = redirect + firstQueryChar + 'token=' + idToken
          }
          console.log('redirecting to ' + redirect)
          localStorage.removeItem('returnUrl');
          localStorage.removeItem('suppressToken');
          localStorage.removeItem('responseType');
          localStorage.removeItem('loginFlow');
          window.location = redirect
        }

      },
      data: function () {
        return {
          get configStrings() {
            return {
              clubName: 'Blackburn Rovers FC',
              productName: 'Rovers Account',
              clubIdentifierName: 'Client Reference',
              clubStreamingPlatformName: 'RoversTV',
              clubWebsiteLink: 'https://www.rovers.co.uk/',
              clubPrivacyPolicyLink: 'https://www.rovers.co.uk/help-and-information/privacy-policy',
              clubSSOHelpLink: 'https://www.rovers.co.uk/',
              clubSSOVerificationEmailAddress: 'no-reply@rovers.co.uk'
            }
          },

          get configValues() {
            return {
              clubRootDomain: 'rovers.co.uk',
              accountConsentRequired: false, // true or false
              accountConsentAge: 13, // numeric value
              accountDoBUpdatesAllowed: false, // true or false
              accountRegistrationPreferencesAreEmailOnly: false, //if true the registration opt-ins only opt users in to email (if false they opt in to all channels)
              accountRequestAddressOnFirstLogin: true, // true or false
              accountProfilePicturesAllowed: false, // true or false
              profilePictures: {
                s3Bucket: 'sso-images.rovers.co.uk'
              },
              accountGenderRequested: true, // true or false
              accountGenderList: [
                '',
                'Male',
                'Female',
                'Other',
                'Prefer not to say'
              ],
              contactPreferencesParentSystem: null,// String (Dummy, XCM, SportsAlliance etc.). null if not relevant
              // Seatgeek integration options
              seatGeekAccountLinkingEnabled: false, // true or false
              seatGeekConfig: {
                liveOrigin: 'https://tickets.rovers.co.uk',
                iframeURL: 'https://tickets.rovers.co.uk/test/'
              },
              // TicketMaster integration options
              ticketMasterAccountLinkingEnabled: false, // true or false
              ticketMasterShowButton: false, // true or false,
              ticketMasterDebugMode: false, // true or false,
              ticketMasterConfig: {
                domain: 'eticketing.co.uk',
                clubDirectory: '/onerovers',
                loginUrl: '/interfaces/mufcsinglelogin/login.aspx',
                uzTokenEnpoint: 'https://tmapi.gc.urbanzoofcservices.co.uk/v1/user/get-token/',
                uzTMLinkEnpoint: 'https://tmapi.gc.urbanzoofcservices.co.uk/v1/user/link/',
                uzTMUnlinkEnpoint: 'https://tmapi.gc.urbanzoofcservices.co.uk/v1/user/unlink/',
                uzTMCreateEnpoint: 'https://tmapi.gc.urbanzoofcservices.co.uk/v1/user/create/'
              },
              // Dummy CRM integration options
              dummyCRMEnabled: false,
              // XCM CRM integration options
              xcmCRMIntegrationEnabled: false,
              xcmConfig: {
                pushDataEndpoint: '',
                contactPreferencesEndpoint: 'https://domain.com/user/preferences/'
              },
              communitySchemeMarketingEnabled: false,
              communityScheme: {
                name: 'Blackburn Rovers FC Community Trust'
              }
            }
          },
          /*
          An array of platforms and related behaviour information 
          that the site trusts in order to perform redirects
          */
          get configTrustedPlatforms() {
            return [
              {
                providor: 'StreamAMG',
                domains: ['blackburnpayments.streamamg.com'],
                requireAddress: false,
                requireAddressMessage: 'In order to buy a streaming pass, you must first set your address',
                requireAddressButton: null
              },
              {
                providor: 'Ticketmaster',
                domains: ['uat.eticketing.co.uk', 'www.eticketing.co.uk'],
                requireAddress: false,
                requireAddressMessage: 'In order to use the ticket website, you must first set your address',
                requireAddressButton: null
              },
              {
                providor: 'RSS',
                domains: ['shop.rovers.co.uk', 'stage-shop.rovers.co.uk'],
                requireAddress: true,
                requireAddressMessage: 'In order to use the club shop, you must first set your address',
                requireAddressButton: 'Save & Continue to Shop'
              },
              {
                providor: 'Gamechanger',
                domains: ['urbanzoo.io'],
                requireAddress: false,
                requireAddressMessage: 'In order use the website, you must first set your address',
                requireAddressButton: null
              },
            ]
          },

          /*
          An array of the items that will be populated in the Official Websites list of the portal
          */
          get configOfficialWebsites() {
            return [
              {
                title: 'Official website',
                URL: 'https://www.rovers.co.uk',
                target: '_blank'
              },
              {
                title: 'Roverstore',
                URL: 'https://www.roverstore.co.uk/',
                target: '_blank'
              },
              {
                title: 'Tickets',
                URL: 'https://www.eticketing.co.uk/onerovers/',
                target: '_blank',
                ticketMasterTokenLogin: false
              },
              {
                title: 'RoversTV',
                URL: 'https://www.rovers.co.uk/videos',
                target: '_blank'
              },
            ]
          }
        }
      }
    })
  }
}
export default GlobalConfig
